module.exports = __webpack_public_path__ + "img/easy.55235238.png";